import { CodeBook } from "@king-ict/eupisi-ui/models";

export interface InstitutionLanguageModel extends CodeBook {
  // The CodeBook Id is the entity Id and the Name is CodeBook Name.
  languageId: number;
  languageName: string;
  modelId: SchoolingModelEnum;
  modelName: string;
  isEnrollmentModule: boolean;
}

export enum SchoolingModelEnum {
  A = 1,
  B,
  C,
}
